import { render, staticRenderFns } from "./TenantEditWorkflow.vue?vue&type=template&id=c5206c28&scoped=true&"
import script from "./TenantEditWorkflow.vue?vue&type=script&lang=js&"
export * from "./TenantEditWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5206c28",
  null
  
)

export default component.exports